<script lang='ts'>
    let className = ""
    export {className as class}
    export let type: "animated" | "static" = "static"

</script>

<svg class={className} version="1.0" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 110 110">
    <g id="logo-xata" class:sparkle={type=="animated"}>
        <path class:sparkle={type=="animated"} d="M12 5.5c0 .3 1.6 3 3.6 6l3.7 5.5-3.7 5.9c-2 3.2-3.6 6.2-3.6 6.5 0 .3 1.1.6 2.5.6 1.8 0 3.2-1.1 5.1-4.2l2.7-4.2 2.4 4.2c2 3.4 3.1 4.2 5.4 4.2 1.6 0 2.9-.2 2.9-.6 0-.3-1.8-3.2-4-6.4l-4.1-6 3.6-5.2C30.4 8.9 32 6.2 32 5.7s-1.2-.7-2.7-.5c-2 .2-3.4 1.4-4.9 4.2l-2.2 3.9-2.1-4.2C18.3 5.7 17.5 5 15 5c-1.7 0-3 .2-3 .5z"/>
        <path class:sparkle={type=="animated"} d="M39.1 16.6C36.9 23 35 28.6 35 29.1s1.1.9 2.5.9c1.8 0 2.6-.7 3.1-2.5.5-2.2 1.1-2.5 5.4-2.5 4.3 0 4.9.3 5.4 2.5.5 1.8 1.3 2.5 3.1 2.5 1.4 0 2.5-.5 2.5-1 0-.9-5.5-17.3-7.5-22.3-.4-1-1.8-1.7-3.5-1.7-2.6 0-3 .6-6.9 11.6zm8.7-.7c1.6 5 1.6 4.8-1.6 4.3-2.8-.4-2.9-.5-1.8-4.3.5-2.1 1.3-3.9 1.6-3.9.4 0 1.2 1.7 1.8 3.9z"/>
        <path class:sparkle={type=="animated"} d="M56.4 6.5c-.9 2.3.5 3.5 4.2 3.5H64v20h5V10h3.5c3.1 0 3.5-.3 3.5-2.5C76 5 76 5 66.5 5c-7.4 0-9.7.3-10.1 1.5z"/>
        <path class:sparkle={type=="animated"} d="M82.9 7.7c-1.5 3.9-7.9 21.7-7.9 22 0 .2 1.1.3 2.5.3 1.8 0 2.8-.7 3.5-2.5.8-2.2 1.6-2.5 5.5-2.5s4.7.3 5.5 2.5c.7 1.8 1.7 2.5 3.5 2.5 1.4 0 2.5-.3 2.4-.8 0-.4-1.9-5.9-4.2-12.2-3.9-10.6-4.4-11.5-7-11.8-2.2-.3-2.9.2-3.8 2.5zM89 19c0 .9-.9 1.5-2.5 1.5-2.8 0-3-.8-1.3-5.6l1.2-3.4 1.2 3c.7 1.7 1.3 3.7 1.4 4.5z"/>
    </g>
    <path d="M81.6 39.4c-2.1.8-5.7 3.3-8 5.5-4.5 4.4-5.6 4.9-5.6 2.6 0-.9-1.1-2.7-2.5-4-2.4-2.4-2.8-2.5-18.1-2.5H31.8l-8.4 8.2c-6.5 6.3-8.7 7.9-9.6 7-.7-.7-1.6-1.2-2-1.2C10.2 55 1 64.3 1 65.9c0 .9 6.5 8.1 14.4 16l14.4 14.4 5.9-5.6c5.1-4.9 5.7-5.9 4.6-7.5-1-1.7-.6-2.4 2.6-5.6l3.7-3.6H70.3l14.4-14.2c7.9-7.9 14.2-14.9 14.1-15.7-.4-2-5.5-4.8-9.8-5.5-2-.3-5.2 0-7.4.8zM92 43.1l3.2 1.2-12.8 12.8L69.5 70H58.2c-12.1 0-13.8.5-19 5.3L36 78.4l-9-8.9-9.1-9 8.4-8.3 8.4-8.2h12.2c12.7 0 15.3.6 17.1 4.1.9 1.6.8 2.6-.4 4.4-1.4 2.2-2.4 2.4-9.8 2.7-6.6.2-8.3.6-8.3 1.8 0 1.2 1.8 1.6 9.4 1.8l9.5.3 7.5-7.5C81.6 42 84.8 40.7 92 43.1zM24.5 72l11.9 12-3.4 3.5-3.4 3.5-12.3-12.2L5 66.6l3.2-3.3C10 61.5 11.6 60 12 60c.3 0 5.9 5.4 12.5 12z"/>
</svg>

<style lang="scss">
    #logo-xata{
        transform-box: fill-box;
        transform-origin: center;
        &.sparkle {
            animation: sparkle 6s linear infinite;
        }
    }

    @keyframes sparkle {
        0% {
            transform: scale(1);
        }
        20% {
            transform: scale(1.1);
        }
        40%, 100% {
            transform: scale(1);
        }
    }
</style>